// extracted by mini-css-extract-plugin
export default {"outfit":"ListPage_outfit__2GnYo","buttonWidth":"ListPage_buttonWidth__GnyS+"};